export default __webpack_public_path__ + "static/media/tzuyu.7d68665b.jpg";